import { useState, useEffect } from 'react';
import {
  createAgeGroupProduct,
  deleteAgeGroupProduct,
  getAgeGroupProductById,
  getAgeGroupProducts,
  updateAgeGroupProduct,
  updateActive
} from '../services/AgeGroupProductsService';
import useAlert from '../../../shared/hooks/useAlert';

export const useAgeGroupProducts = () => {

  const [ageGroupProduct, setAgeGroupProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { alert, showAlert } = useAlert();

  const fetchAgeGroupProducts = async () => {
    setLoading(true);
    try {
      const response = await getAgeGroupProducts();
      setAgeGroupProduct(response.data);
    } catch (err) {
      setError('Failed to fetch Age Group Products');
    } finally {
      setLoading(false);
    }
  };

  const addAgeGroupProduct = async (ageGroupProduct) => {
    try {
      await createAgeGroupProduct(ageGroupProduct);
      fetchAgeGroupProducts();
      showAlert('Created successfully!', 'success');
    } catch {
      setError('Failed to add Age Group Product');
      showAlert('Error creating', 'danger');
    }
  };

  const fetchAgeGroupProductById = async (id) => {
    try {
      const response = await getAgeGroupProductById(id);
      setAgeGroupProduct(ageGroupProduct.map(p => (p.id === id ? response.data : p)));
    } catch {
      setError('Failed to update Age Group Products');
      showAlert('Error creating', 'danger');
    }
  };

  const editAgeGroupProduct = async (id, updatedAgeGroupProduct) => {
    try {
      const response = await updateAgeGroupProduct(id, updatedAgeGroupProduct);
      setAgeGroupProduct(ageGroupProduct.map(p => (p.id === id ? response.data : p)));
      fetchAgeGroupProducts();
      showAlert('Created successfully!', 'success');
    } catch {
      setError('Failed to update Age Group Product');
      showAlert('Error creating', 'danger');
    }
  };

  const removeAgeGroupProduct = async (id) => {
    try {
      await deleteAgeGroupProduct(id);
      setAgeGroupProduct(ageGroupProduct.filter(p => p.id !== id));
      showAlert('Remove successfully!', 'success');
    } catch {
      setError('Failed to delete Age Group Product');
      showAlert('Error creating', 'danger');
    }
  };


  const updateOnActive = async (id, updatedStatus) => {
    try {
      const response = await updateActive(id, updatedStatus);
      setAgeGroupProduct(ageGroupProduct.map(p => (p.id === id ? response.data : p)));
      showAlert('Edited successfully!', 'success');
    } catch {
      setError('Failed to update categories');
      showAlert('Error creating', 'danger');
    }
  };

  useEffect(() => {
    fetchAgeGroupProducts();
  }, []);

  return {
    ageGroupProduct,
    loading,
    error,
    alert,
    addAgeGroupProduct,
    fetchAgeGroupProductById,
    fetchAgeGroupProducts,
    editAgeGroupProduct,
    removeAgeGroupProduct,
    updateOnActive
  };

};
